"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarginRiskRating = exports.HEALTHY_THRESHOLD = exports.MONITOR_THRESHOLD = exports.WARNING_THRESHOLD = exports.AT_RISK_THRESHOLD = void 0;
const types_1 = require("../types");
const AT_RISK_THRESHOLD = 50;
exports.AT_RISK_THRESHOLD = AT_RISK_THRESHOLD;
const WARNING_THRESHOLD = 80;
exports.WARNING_THRESHOLD = WARNING_THRESHOLD;
const MONITOR_THRESHOLD = 100;
exports.MONITOR_THRESHOLD = MONITOR_THRESHOLD;
const HEALTHY_THRESHOLD = 150;
exports.HEALTHY_THRESHOLD = HEALTHY_THRESHOLD;
const getMarginRiskRating = (usedMargin, marginLevel) => {
    if (usedMargin.eq(0)) {
        return types_1.MarginRisk.None;
    }
    else if (marginLevel.lt(AT_RISK_THRESHOLD)) {
        return types_1.MarginRisk.StopOut;
    }
    else if (marginLevel.lt(WARNING_THRESHOLD)) {
        return types_1.MarginRisk.AtRisk;
    }
    else if (marginLevel.lt(MONITOR_THRESHOLD)) {
        return types_1.MarginRisk.Warning;
    }
    else if (marginLevel.lt(HEALTHY_THRESHOLD)) {
        return types_1.MarginRisk.Monitor;
    }
    else {
        return types_1.MarginRisk.Healthy;
    }
};
exports.getMarginRiskRating = getMarginRiskRating;
//# sourceMappingURL=riskRating.js.map